export default __webpack_public_path__ + "static/media/ajr.0edab93d.jpg";